import React, { useState } from 'react';

import { Box, Container } from '@mui/material';

import PageHeader from '~/components/Common/Elements/PageHeader';
import SectionNavigation from '~/components/Common/Elements/SectionNavigation';
import SectionNavigationLayout from '~/components/Common/Elements/SectionNavigationLayout';

import Color from './Color';
import Ranking from './Ranking';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel({ children, value, index }: TabPanelProps) {
  return (
    <div role="tabpanel" hidden={value !== index}>
      {value === index && <Box mt={2}>{children}</Box>}
    </div>
  );
}

export default function ShopPage() {
  const [currentTab, setCurrentTab] = useState(0);

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setCurrentTab(newValue);
  };

  return (
    <Container maxWidth="xl">
      <PageHeader title="Shop" />

      <Box mt={2}>
        <SectionNavigationLayout
          navigation={
            <SectionNavigation
              label="Shop sections"
              currentTab={String(currentTab)}
              groups={[
                {
                  items: ['Colors', 'Ranking'].map((label, index) => ({
                    id: String(index),
                    label,
                  })),
                },
              ]}
              onSelect={(event, id) => {
                event.preventDefault();
                handleTabChange(event, Number(id));
              }}
            />
          }
        >
          <TabPanel value={currentTab} index={0}>
            <Color />
          </TabPanel>

          <TabPanel value={currentTab} index={1}>
            <Ranking />
          </TabPanel>
        </SectionNavigationLayout>
      </Box>
    </Container>
  );
}
